import { LocalizedMessage } from '@client/internationalization';
import { selectorFeatures } from '@client/modules/app-context/duck';
import { BulletList, BulletListItem } from '@client/modules/shared-components/BulletList';
import { ContactUsButton } from '@client/shared-components/ContactUsButton';
import { useGlobalFaqDialog } from '@client/modules/Faq/FaqHelpCenter/FaqDialogProvider';
import { makeStyles } from '@material-ui/core';
import { Body } from '@minna-technologies/minna-ui/components/Typography/Body';
import type { FC } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles({
  content: {
    margin: '0 16px 8px',
  },
  sectionMargin: {
    margin: '0 0 24px',
  },
});

export interface Props {
  serviceProviderName: string;
  pageName: string;
}

export const NotACancellableSubscriptionContent: FC<Props> = ({ serviceProviderName, pageName }) => {
  const classes = useStyles();
  const features = useSelector(selectorFeatures);
  const openFaqDialog = useGlobalFaqDialog();

  return (
    <div className={classes.content}>
      <div className={classes.sectionMargin}>
        <Body>
          <LocalizedMessage id="thisCouldBeBecause" />
        </Body>
        <BulletList>
          <BulletListItem>
            <LocalizedMessage id="notCancellableReason1" />
          </BulletListItem>
          <BulletListItem>
            <LocalizedMessage id="notCancellableReason2" />
          </BulletListItem>
        </BulletList>
        {features.helpCenter.enabled && (
          <Body>
            <LocalizedMessage id="feelFreeToContactUs" />
          </Body>
        )}
      </div>
      {features.helpCenter.enabled && (
        <ContactUsButton
          pageName={pageName}
          insightCardName="CancellationOutcomeNotACancellableSubscription"
          supplierName={serviceProviderName}
          openFaqDialog={openFaqDialog}
        />
      )}
    </div>
  );
};
